import type { Contact } from '../../../domain/contact';
import UrlService from '../../../services/UrlService';
import type { LinkedinContactsPayload } from '../api';

export const createLinkedinContactsPayload = (
  collectedLinkedinContacts: Partial<Contact>[]
): LinkedinContactsPayload[] =>
  collectedLinkedinContacts
    .map(
      ({
        linkedin,
        name = '',
        numericCompanyLinkedinIds,
        companyName,
        companyNames,
        linkedinId,
        linkedinSalesNavId,
      }) => {
        const payloadCompanyNames = companyNames ? companyNames : [companyName];
        const linkedinIdFromUrl = linkedin && UrlService.getContactLinkedinIdFromUrl(new URL(linkedin));
        const finalLinkedinId = linkedinId ?? linkedinIdFromUrl;

        if (!name && !finalLinkedinId) {
          return;
        }

        return {
          numericCompanyLinkedinIds: numericCompanyLinkedinIds?.filter(Boolean) || [],
          fullName: name,
          companyNames: payloadCompanyNames.filter(Boolean),
          ...(finalLinkedinId ? { linkedinId: finalLinkedinId } : {}),
          ...(linkedinSalesNavId ? { linkedinSalesNavId } : {}),
        };
      }
    )
    .filter(Boolean) as LinkedinContactsPayload[];
